var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { selectResourceAmountInfo } from "../balancingSelectors/selectBalancingResources";
import { IdResource } from "../constants/IdResource";
import { EventType } from "../features/balancing/types/BalancingCore";
import { TypeNumberRounding } from "../features/generic/round-format/TypeNumberRounding";
import { utilBuff } from "../utils/utilBuff";
import { selectEventBuffByTargetId } from "./selectBuffsInfo";
import { selectActiveDiscountEventInfoByEventType } from "./selectEventInfo";
import { selectNotEnoughResourcesMissingResources } from "./selectNotEnoughResources";
import { selectOutskirtBuildingInfo, selectOutskirtBuildingLevel, selectOutskirtBuildingMaxLevel, } from "./selectOutskirtBuildingInfo";
export var selectOutskirtBuildingUpgradeInfo = function (state, outskirtBuildingId) {
    var outskirtBuildingInfo = selectOutskirtBuildingInfo(state, outskirtBuildingId);
    var outskirtBuildingLevel = selectOutskirtBuildingLevel(state, outskirtBuildingId);
    var outsideBuildingStage = outskirtBuildingInfo.balancing.outsideBuildingStage;
    var currentStage = outsideBuildingStage[outskirtBuildingLevel - 1];
    var nextStage = outsideBuildingStage[outskirtBuildingLevel];
    var upgradeTextLoca = outskirtBuildingInfo.balancing.locaKeyUpgradeDesc;
    var maxLevel = selectOutskirtBuildingMaxLevel(state, outskirtBuildingId);
    var upgradeEffects = outsideBuildingStage[outskirtBuildingLevel]
        ? outsideBuildingStage[outskirtBuildingLevel].shownStat || []
        : [];
    return {
        currentStage: currentStage,
        maxLevel: maxLevel,
        nextStage: nextStage,
        upgradeEffects: upgradeEffects,
        upgradeTextLoca: upgradeTextLoca,
    };
};
export var selectOutskirtDisplayLevelById = function (state, outskirtBuildingId) {
    var info = selectOutskirtBuildingInfo(state, outskirtBuildingId);
    return info !== undefined && info.proto !== undefined && info.proto.stage !== undefined
        ? info.proto.stage
        : undefined;
};
export var selectOutskirtBuildingUpgradeRequirementsResourceInfo = function (state, outskirtBuildingId) {
    var outskirtBuildingInfo = selectOutskirtBuildingInfo(state, outskirtBuildingId);
    var outskirtBuildingLevel = selectOutskirtBuildingLevel(state, outskirtBuildingId);
    var hasCost = outskirtBuildingInfo.balancing.outsideBuildingStage &&
        outskirtBuildingInfo.balancing.outsideBuildingStage[outskirtBuildingLevel] &&
        outskirtBuildingInfo.balancing.outsideBuildingStage[outskirtBuildingLevel].cost;
    var cost = hasCost
        ? outskirtBuildingInfo.balancing.outsideBuildingStage[outskirtBuildingLevel].cost
        : [];
    return cost.map(function (requiredResource) {
        return selectResourceAmountInfo(requiredResource.resourceId, requiredResource.amount);
    });
};
export var selectOutskirtBuildingUpgradeRequirementsResourceInfoWithDiscount = function (state, outskirtBuildingId) {
    var event = selectActiveDiscountEventInfoByEventType(state, EventType.OutskirtDiscount);
    var goldBuff = event != undefined ? selectEventBuffByTargetId(state, event, IdResource.Gold) : undefined;
    var resourceInfos = selectOutskirtBuildingUpgradeRequirementsResourceInfo(state, outskirtBuildingId);
    return goldBuff != undefined
        ? resourceInfos.map(function (resourceInfo) {
            var amount = resourceInfo.amount;
            if (resourceInfo.id === IdResource.Gold) {
                amount = utilBuff.applyTo(amount, goldBuff, TypeNumberRounding.Ceil);
            }
            return __assign({}, resourceInfo, { amount: amount });
        })
        : resourceInfos;
};
export var selectOutskirtBuildingUpgradeMissingRequirements = function (state, outskirtBuildingId) {
    var standardCostInfo = selectOutskirtBuildingUpgradeRequirementsResourceInfoWithDiscount(state, outskirtBuildingId);
    var standardCost = standardCostInfo.map(function (resource) {
        return {
            amount: resource.amount,
            typeId: resource.id,
        };
    });
    return selectNotEnoughResourcesMissingResources(state, standardCost);
};
export var selectOutskirtBuildingUpgradeGoldCost = function (state, outskirtBuildingId) {
    var costInfo = selectOutskirtBuildingUpgradeRequirementsResourceInfoWithDiscount(state, outskirtBuildingId);
    return costInfo.reduce(function (acc, resourceData) {
        return acc.add(resourceData.id === IdResource.Gold ? resourceData.amount : 0);
    }, Long.ZERO);
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectOutskirtBuildingUpgradeInfo.ts
// module id = 293
// module chunks = 3